import { useEffect, useState, type ReactNode } from 'react'

import { Divider, Modal, useModalStackContext } from '@mantine/core'

import DNButton from 'src/components/Buttons/Button/DNButton'
import IconTrash from 'src/icons/IconTrash'

const DeleteModal = ({
  title,
  description = '' as ReactNode,
  opened,
  close,
  onDelete,
  stackId = undefined,
}) => {
  const [isDeleting, setIsDeleting] = useState(false)
  const stackCtx = useModalStackContext()

  // Mantine gap: Modal's stack-register useEffect has no cleanup, so
  // unmounting while opened leaks the stackId in Modal.Stack. Mirrors DnDrawer.
  useEffect(() => {
    return () => {
      if (stackCtx && stackId) {
        stackCtx.removeModal(stackId)
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const handleDelete = async () => {
    setIsDeleting(true)
    await onDelete()
    setIsDeleting(false)
    close()
  }

  return (
    <Modal
      opened={opened}
      onClose={close}
      centered
      size="35%"
      withCloseButton={false}
      stackId={stackId}
    >
      <div className="flex flex-col gap-4">
        <IconTrash
          className={
            'h-10 w-10 rounded bg-doubleNickel-error-50 fill-doubleNickel-white stroke-doubleNickel-error-600 p-2'
          }
        />
        <div className="flex flex-col items-start ">
          <div className="text-based text-center font-semibold text-doubleNickel-gray-900">
            {title}
          </div>
          <div className="text-sm text-doubleNickel-gray-700">
            {description || 'This action cannot be undone.'}
          </div>
        </div>
        <Divider />
        <div className="flex w-full flex-row justify-end gap-3">
          <DNButton variant="outline" onClick={close}>
            Cancel
          </DNButton>
          <DNButton
            variant="error"
            onClick={handleDelete}
            loading={isDeleting}
            className="min-w-20"
          >
            Confirm
          </DNButton>
        </div>
      </div>
    </Modal>
  )
}

export default DeleteModal
